import { Injectable } from '@angular/core';

import { Observable } from 'rxjs/Observable';

import { User } from 'app/models';
import { environment } from 'environments/environment';

import { HttpService } from './http.service';

const usersUrl = `${environment.apiUrl}/users`;
const userDetailUrl = `${environment.apiUrl}/userdetail`;
const userIdDetailUrl = userId => `${environment.apiUrl}/userdetail/${userId}`;

@Injectable()
export class UserService {
  constructor(private readonly httpService: HttpService) {}

  getUsers(): Observable<User[]> {
    return this.httpService.get<User[]>(usersUrl).map(users => this.enrich(users));
  }

  getUser(userId: number): Observable<User> {
    return this.httpService.get<User>(userIdDetailUrl(userId));
  }

  getLoggedInUser(): Observable<User> {
    return this.httpService.get<User>(userDetailUrl);
  }

  createUser(user: User): Observable<User> {
    return this.httpService.post(usersUrl, user);
  }

  updateUser(user: User): Observable<User> {
    return this.httpService.put(userIdDetailUrl(user.id), user).map(response => response.json() as User);
  }

  deleteUser(userId: number): Observable<User> {
    return this.httpService.delete(userIdDetailUrl(userId)).map(response => response.json() as User);
  }

  private enrich(users) {
    const usersWithName = [];
    users.forEach(user => {
      user['name'] = `${user.firstName} ${user.lastName}`;
      usersWithName.push(user);
    });
    return usersWithName;
  }
}



// WEBPACK FOOTER //
// ./src/app/services/user.service.ts